import { FaroCoreApiTypes } from "@stellar/core-api-client";

export function getNumberedEnv(host: string): string | null {
  const numberedEnv = host.match(/^dev\d{1,2}/);
  return numberedEnv?.length ? numberedEnv[0] : null;
}

export function isHostNumberedEnv(host: string): boolean {
  return /^dev\d{1,2}/.test(host);
}

export const appVersion: string = "2.0.285";
export const appTimestamp: string = "2026-11-04T13:49:14.000Z";
export const commitId: string = "ec7256322d82401be3c5d320c488bb5cf11f951e";
export const commitUrl: string = "https://dev.azure.com/faro-connect/Stellar/_git/EntryPage/commit/ec7256322d82401be3c5d320c488bb5cf11f951e?refName=refs%2Fheads%2Fmaster";
export const pullRequestId: string = "0";
export const pullRequestUrl: string = "https://dev.azure.com/faro-connect/Stellar/_git/EntryPage/pullrequest/0";
export const jiraTicketId: string = "0";
export const jiraTicketUrl: string = "https://faro01.atlassian.net/browse/0";

export const localizeKey = "iKNI0OJMw3RLe";
export const sentryDSNKey =
  "https://20e8bee1014c8ffa9f8b67f3d69a9709@o381590.ingest.sentry.io/4505912288411648";

export const isNumberedEnv = isHostNumberedEnv(globalThis.location.host);
export const numberedEnv = isNumberedEnv
  ? getNumberedEnv(globalThis.location.host)
  : null;

/** Available authentication providers in EU */
export const OAUTH_PROVIDERS_EU: FaroCoreApiTypes.OAuthProvider[] = [
  "autodesk",
  "procore",
  "faro-sphere",
];

/** Available authentication providers in COM */
export const OAUTH_PROVIDERS_COM: FaroCoreApiTypes.OAuthProvider[] = [
  "autodesk",
  "procore",
  "faro-sphere",
  "google",
  "apple",
];

/** URLs for legal documents */
export const TERMS_OF_SERVICE_URL =
  "https://www.faro.com/Terms-and-Conditions/Sphere-Terms/Sphere-XG-Terms-of-Service";
export const PRIVACY_POLICY_URL = "https://www.faro.com/Privacy-Policy";
export const DATA_PROCESSING_AGREEMENT_URL =
  "https://www.faro.com/Terms-and-Conditions/Sphere-Terms/Data-Processing-Agreement";
export const COOKIE_POLICY_URL = "https://www.faro.com/Cookie-Policy";
